<template>
  <div class="smartSpot">
    <div class="module">
      <ul class="ul">
        <li class="li" v-for="(item, index) in moduleList" :key="index" @click="handleCaseClick">
          <div class="img">
            <img :src="item.img" alt="" />
          </div>
          <div class="name">
            {{ item.name }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { enableCasePreview, getToken } from '@/utils/auth';

export default {
  name: 'smartSpot',
  data() {
    return {
      moduleList: [
        {
          img: require('./img/ajgz.png'),
          name: '安吉古镇智慧旅游'
        },
        {
          img: require('./img/ajyc.png'),
          name: '安吉余村大数据中心'
        },
        {
          img: require('./img/cs.png'),
          name: '曹山景区智慧旅游'
        },
        {
          img: require('./img/dh.png'),
          name: '东湖景区'
        },
        {
          img: require('./img/hy.jpg'),
          name: '河阳古居民智慧景区'
        },
        {
          img: require('./img/hsw.png'),
          name: '横山坞'
        },
        {
          img: require('./img/lms.png'),
          name: '浪漫山川智慧旅游'
        },
        {
          img: require('./img/lf.png'),
          name: '灵峰度假区智慧旅游'
        },
        {
          img: require('./img/19f.png'),
          name: '十九峰综合'
        },
        {
          img: require('./img/sms.png'),
          name: '四面山智慧景区'
        },
        {
          img: require('./img/cfb.png'),
          name: '长寿报福镇'
        },
        {
          img: require('./img/lh.png'),
          name: '中国莲花景区'
        }
      ]
    };
  },
  methods: {
    handleCaseClick() {
      if (getToken()) {
        enableCasePreview();
        this.$emit('show-success');
        return;
      }
      this.$router.push('/login?redirect=%2Fcase&casePreview=1');
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.smartSpot {
  .module {
    margin: 0 auto;
    width: 100%;
    height: 846px;
    background: #ffffff;
    border: 1px solid #979797;
    .ul {
      display: flex;
      flex-flow: wrap;
      justify-content: space-evenly;
      .li {
        margin-top: 144px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        .img {
          img {
            width: 100px;
            height: 100px;
          }
        }
        .name {
          text-align: center;
          width: 300px;
          height: 33px;
          font-size: 24px;
          font-family: 'PingFang';
          color: #000000;
          line-height: 33px;
          margin-top: 52px;
        }
      }
    }
  }
}
</style>
